import React, { FC } from 'react'

import { useLocation } from 'react-router-dom'

import { AppIcon } from '@app/components/AppIcon'
import { PAGE_ORGANIZATION_SETTINGS } from '@app/constants/navigation'

import { SidebarOrgSettingsLink } from './styled'

const SidebarOrgSettings: FC = () => {
	const location = useLocation()

	return (
		<SidebarOrgSettingsLink
			to={PAGE_ORGANIZATION_SETTINGS}
			open={location.pathname?.includes(PAGE_ORGANIZATION_SETTINGS)}
		>
			<AppIcon type={'connectWhite'} />
		</SidebarOrgSettingsLink>
	)
}

export default SidebarOrgSettings
